import { memo } from 'react';
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  useEventCallback,
} from '@mui/material';
import { FormActualResidenceVM, ForeignVM } from 'practice/view-models/pratice-actual-residence';
import { FormikErrors, FormikTouched } from 'formik';
import ItalianForm from './italian';
import ForeignForm from './foreign';
import { ItalianVM } from 'shell/view-models/register-office-practice-vm';

interface FormProps {
  values?: FormActualResidenceVM;
  onChange: (
    key: keyof FormActualResidenceVM,
    value: FormActualResidenceVM[keyof FormActualResidenceVM]
  ) => void;
  errors?: FormikErrors<FormActualResidenceVM>;
  touched?: FormikTouched<FormActualResidenceVM>;
  disabled?: boolean;
}

const AccordionNewReidenceFormComponent = ({
  values,
  onChange,
  errors,
  touched,
  disabled,
}: FormProps): React.ReactElement => {
  const onChangeItalian = useEventCallback(
    (key: keyof ItalianVM, value: ItalianVM[keyof ItalianVM]) => {
      onChange('italian', {
        ...(values?.italian || {}),
        [key]: value,
      });
    }
  );

  const onChangesItalian = useEventCallback((valuesItalian: ItalianVM) => {
    onChange('italian', {
      ...(valuesItalian || {}),
    });
  });

  const onChangeForeign = useEventCallback(
    (key: keyof ForeignVM, value: ForeignVM[keyof ForeignVM]) => {
      onChange('foreign', {
        ...(values?.foreign || {}),
        [key]: value,
      });
    }
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Residenza"
            id="checkedResidence"
            value={values?.checkedResidence ? 'true' : 'false'}
            onChange={() => {
              onChange('checkedResidence', !Boolean(values?.checkedResidence));
            }}
          >
            <FormControlLabel
              disabled={!disabled}
              value="false"
              control={<Radio />}
              label="Residenza Italia"
            />
            <FormControlLabel
              disabled={!disabled}
              value="true"
              control={<Radio />}
              label="Residenza Estera"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      {values?.checkedResidence ? (
        <ForeignForm
          onChange={onChangeForeign}
          values={values?.foreign}
          errors={errors?.foreign as unknown as FormikErrors<ForeignVM>}
          touched={touched?.foreign as unknown as FormikTouched<ForeignVM>}
          disabled={disabled}
        />
      ) : (
        <ItalianForm
          onChange={onChangeItalian}
          onChanges={onChangesItalian}
          values={values?.italian}
          errors={errors?.italian as unknown as FormikErrors<ItalianVM>}
          touched={touched?.italian as unknown as FormikTouched<ItalianVM>}
          disabled={disabled}
        />
      )}
    </Grid>
  );
};

AccordionNewReidenceFormComponent.displayName = 'Accordion New Residence Form';

const AccordionNewReidenceForm = memo(AccordionNewReidenceFormComponent);

export default AccordionNewReidenceForm;
